import React from 'react';
import PropTypes from 'prop-types';
import styles from './SsoSettings.module.less';
import EnforceAuth from './EnforceAuth';

const SsoSettings = (props) => {
  return (
    <div className={styles.settingsContainer}>
      <div className={styles.header}>{gettext('Single sign-on (SSO) Settings')}</div>
      <p className={styles.text}>
        {gettext(
          'Forcing your users to log in with a 3rd party SSO (single sign-on) will demand all users in your ' +
            'organization to log into Pipl using the selected SSO service only. Please be sure to update your ' +
            'existing user list to ensure all users have access to the SSO authentication method.',
        )}
      </p>
      <EnforceAuth
        auth="Google"
        status={props.googleStatus}
        disableLogin={props.disableGoogleLogin}
        enableLogin={props.enableGoogleLogin}
        loginUpdateStatus={props.googleLoginUpdateStatus}
        isAbleToEnforceLogin={props.isAbleToEnforceGoogleLogin}
      />
      <EnforceAuth
        auth="Organization"
        status={props.oidcStatus}
        disableLogin={props.disableOidcLogin}
        enableLogin={props.enableOidcLogin}
        loginUpdateStatus={props.oidcLoginUpdateStatus}
        isAbleToEnforceLogin={props.isAbleToEnforceOidcLogin}
      />
    </div>
  );
};

SsoSettings.propTypes = {
  googleStatus: PropTypes.bool,
  amazonStatus: PropTypes.bool,
  oidcStatus: PropTypes.bool,
  disableGoogleLogin: PropTypes.func,
  disableAmazonLogin: PropTypes.func,
  disableOidcLogin: PropTypes.func,
  enableGoogleLogin: PropTypes.func,
  enableAmazonLogin: PropTypes.func,
  enableOidcLogin: PropTypes.func,
  googleLoginUpdateStatus: PropTypes.bool,
  amazonLoginUpdateStatus: PropTypes.bool,
  oidcLoginUpdateStatus: PropTypes.bool,
  isAbleToEnforceGoogleLogin: PropTypes.bool,
  isAbleToEnforceAmazonLogin: PropTypes.bool,
  isAbleToEnforceOidcLogin: PropTypes.bool,
};

export default SsoSettings;
